import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=f71091dc&scoped=true&"
import script from "./NewTag.vue?vue&type=script&lang=js&"
export * from "./NewTag.vue?vue&type=script&lang=js&"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=f71091dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71091dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f71091dc')) {
      api.createRecord('f71091dc', component.options)
    } else {
      api.reload('f71091dc', component.options)
    }
    module.hot.accept("./NewTag.vue?vue&type=template&id=f71091dc&scoped=true&", function () {
      api.rerender('f71091dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/settings/NewTag.vue"
export default component.exports